<template>
    <div v-if="props?.title" class="contentFooterList">
        <p :style="{ color: props?.isdark ? '#FFF' : '#252525' }">{{ props?.title }}</p>
        <div class="contentFooterC" :style="{ display: 'block', background: props?.isdark ? '#272833' : '#F5F5F5' }">
            <ul>
                <li v-for="(data, index) in list" :key="'ac-' + index">
                    <a :style="{ color: props?.isdark ? '#E7E7ED' : '#252525' }" :href="data.href">{{ data?.label }}</a>
                </li>
            </ul>
        </div>
    </div>
    <div v-if="props?.title" class="contentFooterListResponsive">
        <button type="button" class="collapsibleFooter" :style="{ background: props?.isdark ? '#272833' : '#F5F5F5' }"
            @click="toggle">
            <p :style="{ color: props?.isdark ? '#E7E7ED' : '#252525' }">{{ props?.title }}</p>
            <span :style="{ color: props?.isdark ? '#E7E7ED' : '#252525' }" class="rotate-icon-footerv2"
                :class="{ 'rotate-icon-footerv2-open': isActive }">></span>
        </button>
        <div class="contentFooterC"
            :style="{ display: isActive ? 'block' : 'none', background: props?.isdark ? '#272833' : '#F5F5F5' }">
            <ul>
                <li v-for="(data, index) in list" :key="'ac-' + index">
                    <a :style="{ color: props?.isdark ? '#E7E7ED' : '#252525' }" :href="data.href">{{ data?.label }}</a>
                </li>
            </ul>
        </div>
    </div>
    <hr v-if="!props?.isdark" class="contentFooterListResponsive" />
</template>

<script setup>
import { ref, defineProps } from 'vue';
import '../../../assets/css/config.css'

const props = defineProps({
    isdark: {
        type: Boolean,
        default: false
    },
    title: {
        type: String,
        default: ''
    },
    list: {
        default: []
    },
});

const isActive = ref(false);
const toggle = () => { isActive.value = !isActive.value; }; 
</script>

<style scoped>
@media (min-width: 1033px) {
    .contentFooterListResponsive {
        display: none;
    }

    .contentFooterC {
        padding: 8px 9px !important;
    }
}

@media (max-width: 1034px) {
    .contentFooterList {
        display: none;
    }
}

.contentFooterList p {
    font-family: Rubik-semibold, sans-serif;
    padding-inline: 8px;
}

.rotate-icon-footerv2 {
    display: inline-block;
    transition: transform .2s ease-out;
    transform: rotate(90deg) scaleX(0.5);
    font-weight: 700;
    font-size: 20px;
    font-family: cursive !important;
}

.collapsibleFooter p {
    font-family: Rubik-semibold, sans-serif;
    margin: 0
}

.rotate-icon-footerv2-open {
    transition: transform .2s ease-out;
    transform: rotate(0) scaleX(0.5);
}

.collapsibleFooter {
    justify-content: space-between;
    display: flex;
    align-items: center;
    cursor: pointer;
    width: 100%;
    border: none;
    padding: 10px 16px;
    text-align: left;
    outline: none;
    font-size: 15px;
}

.contentFooterC {
    padding: 8px 16px;
    display: none;
    overflow: hidden;
    background-color: #f1f1f1;
}
</style>